"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");

var BaseTask_1 = require("./BaseTask");
/**
 * [[ReceiveVideoInputTask]] acquires a video input from [[DeviceController]].
 */


var ReceiveVideoInputTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(ReceiveVideoInputTask, _BaseTask_1$default);

  var _super = _createSuper(ReceiveVideoInputTask);

  function ReceiveVideoInputTask(context) {
    var _this;

    _classCallCheck(this, ReceiveVideoInputTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'ReceiveVideoInputTask';
    return _this;
  }

  _createClass(ReceiveVideoInputTask, [{
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var receiveEnabled, localTile, videoInput, encodingParams, videoTracks, attendeeId, trackSettings, constraint, externalUserId, i, track;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // TODO: move videoDuplexMode and videoCaptureAndEncodeParameters to video tile controller
                receiveEnabled = this.context.videoDuplexMode === SignalingProtocol_js_1.SdkStreamServiceType.RX || this.context.videoDuplexMode === SignalingProtocol_js_1.SdkStreamServiceType.DUPLEX;

                if (this.context.videoTileController.hasStartedLocalVideoTile()) {
                  this.context.videoDuplexMode = receiveEnabled ? SignalingProtocol_js_1.SdkStreamServiceType.DUPLEX : SignalingProtocol_js_1.SdkStreamServiceType.TX;
                } else {
                  this.context.videoDuplexMode = receiveEnabled ? SignalingProtocol_js_1.SdkStreamServiceType.RX : 0;
                }

                this.context.videoCaptureAndEncodeParameter = this.context.videoUplinkBandwidthPolicy.chooseCaptureAndEncodeParameters();

                if (this.context.videoTileController.hasStartedLocalVideoTile()) {
                  _context.next = 7;
                  break;
                }

                this.context.logger.info('has not started local video tile');

                if (this.context.activeVideoInput) {
                  this.stopVideoInput(); // Indicate to the stream index that we are no longer sending video.  We will
                  // no longer be tracking irrelevant local sending bitrates sent via received Bitrate message, nor will
                  // we track any spurious allocated stream IDs from the backend.

                  this.context.videoStreamIndex.integrateUplinkPolicyDecision([]);
                }

                return _context.abrupt("return");

              case 7:
                // TODO: bind after ICE connection started in case of a failure to resubscribe
                //       or perform error handling to unbind video stream.
                localTile = this.context.videoTileController.getLocalVideoTile();
                videoInput = null;
                _context.prev = 9;
                _context.next = 12;
                return this.context.mediaStreamBroker.acquireVideoInputStream();

              case 12:
                videoInput = _context.sent;
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](9);
                this.context.logger.warn('could not acquire video input from current device');

              case 18:
                if (this.context.enableSimulcast) {
                  encodingParams = this.context.videoUplinkBandwidthPolicy.chooseEncodingParameters();
                  this.context.videoStreamIndex.integrateUplinkPolicyDecision(Array.from(encodingParams.values()));
                }

                this.context.activeVideoInput = videoInput;

                if (!videoInput) {
                  _context.next = 40;
                  break;
                }

                videoTracks = videoInput.getVideoTracks(); // There can be a race condition when there are several audioVideo.update calls (e.g., calling
                // startLocalVideoTile and stopLocalVideoTile at the same time)
                // that causes the video stream to not contain any video track.
                // This should recovers in the next update call.

                if (!(!videoTracks || videoTracks.length === 0)) {
                  _context.next = 24;
                  break;
                }

                return _context.abrupt("return");

              case 24:
                attendeeId = this.context.meetingSessionConfiguration.credentials.attendeeId;
                trackSettings = videoTracks[0].getSettings();

                if (!this.context.enableSimulcast) {
                  _context.next = 37;
                  break;
                }

                constraint = this.context.videoUplinkBandwidthPolicy.chooseMediaTrackConstraints();
                this.context.logger.info("simulcast: choose constraint ".concat(JSON.stringify(constraint)));
                _context.prev = 29;
                _context.next = 32;
                return videoTracks[0].applyConstraints(constraint);

              case 32:
                _context.next = 37;
                break;

              case 34:
                _context.prev = 34;
                _context.t1 = _context["catch"](29);
                this.context.logger.info('simulcast: pass video without more constraint');

              case 37:
                externalUserId = this.context.audioVideoController.configuration.credentials.externalUserId;
                localTile.bindVideoStream(attendeeId, true, videoInput, trackSettings.width, trackSettings.height, null, externalUserId);

                for (i = 0; i < videoTracks.length; i++) {
                  track = videoTracks[i];
                  this.logger.info("using video device label=".concat(track.label, " id=").concat(track.id));
                  this.context.videoDeviceInformation['current_camera_name'] = track.label;
                  this.context.videoDeviceInformation['current_camera_id'] = track.id;
                }

              case 40:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 15], [29, 34]]);
      }));
    }
  }, {
    key: "stopVideoInput",
    value: function stopVideoInput() {
      this.context.mediaStreamBroker.releaseMediaStream(this.context.activeVideoInput);
      this.context.activeVideoInput = null;
    }
  }]);

  return ReceiveVideoInputTask;
}(BaseTask_1.default);

exports.default = ReceiveVideoInputTask;